import { defineStore } from "pinia";
import { computed, reactive, ref, watch } from "vue";
import { tableDataHeaders } from "@/exampleData/tableData";
import axios from "axios";
import environment from "@/environment";
import {useSources} from "@/stores/sources-store";

export const useTableStore = defineStore("table", () => {
    const listData = ref([]);
    const filteredListData = ref([]);
    const filters = reactive({
        Region: "",
        SubRegion: "",
        Country: "",
        Language: "",
        CreatedFrom: "",
        CreatedTo: ""
    });
    const headersData = reactive([...tableDataHeaders]);
    const filterOptions = reactive({
        regionOptions: [],
        subRegionOptions: [],
        countryOptions: [],
        languageOptions: [
            { value: "russian", label: "Русский" },
            { value: "english", label: "Английский" },
            { value: "french", label: "Французский" },
            { value: "german", label: "Немецкий" },
            { value: "italian", label: "Итальянский" },
            { value: "portuguese", label: "Португальский" },
            { value: "spanish", label: "Испанский" },
            { value: "default", label: "Другой" },
        ],
        typeOptions: [
            { value: "rss", label: "RSS" },
            { value: "page", label: "Page" },
            { value: "vkontakte", label: "VKontakte" },
            { value: "instagram", label: "Instagram" },
            { value: "facebook", label: "Facebook" },
            { value: "telegram", label: "Telegram" },
            { value: "twitter", label: "Twitter" },
            { value: "dzen", label: "Dzen" },
            { value: "youtube", label: "Youtube" },
        ],
    });
    const pagination = ref({});
    let activeCells = ref(new Set());
    let wasUpdatedCells = ref(new Set());
    let activeCellOnlyOne = ref("");
    let prevActiveCellOnlyOne = ref("");
    let quantityUpdatedData = ref(0);
    let quantityReplaceData = ref(0);
    let ctrlIsPressed = ref(false);
    let startedActiveCell = ref(null);
    let requestIsExecution = ref(false);
    let createTagModalIsActive = ref(false);
    let createFeedModalIsActive = ref(false);
    let activeRow = ref(null);

    const toggleIsEnabledFeeds = async (feed) => {

        const sourceStore = useSources();
        await sourceStore.updateSource(feed.id, {"is_enabled": feed.is_enabled});
    };

    const resetFilter = () => {
        for (const key in filters) {
            if (filters[key]) {
                filters[key] = "";
            }
        }
    };

    const btnResetFilterIsDisabled = computed(() => {
        return !Object.values(filters).some(value => value !== "");
    });

    watch(activeCellOnlyOne, (newValue) => {
        if (newValue) {
            prevActiveCellOnlyOne.value = newValue;
        } else {
            prevActiveCellOnlyOne.value = "";
        }
        if (activeCells.value.size) {
            activeCells.value.clear();
        }
    });

    return {
        filters,
        headersData,
        listData,
        filteredListData,
        activeCells,
        activeCellOnlyOne,
        activeRow,
        prevActiveCellOnlyOne,
        ctrlIsPressed,
        wasUpdatedCells,
        quantityUpdatedData,
        quantityReplaceData,
        startedActiveCell,
        requestIsExecution,
        filterOptions,
        pagination,
        createTagModalIsActive,
        createFeedModalIsActive,
        btnResetFilterIsDisabled,
        toggleIsEnabledFeeds,
        resetFilter
    };
});
